'use client';

import { useState } from 'react';
import { addToShortlist, getShortlist, isShortlistFull, removeFromShortlist } from '@tac/shortlist';
import { Minus, Plus } from '@tac/icons';
import { Button } from '@/components/ui/button';
import { CompareLimitDialog } from '@/components/v2/compare-limit-dialog';
import { TrackingEventWrapper } from '@/components/tracking-event-wrapper';

type AddToCompareProps = {
  vehicleId: string;
  make: string;
  model: string;
};

export function AddToCompare({ vehicleId, make, model }: AddToCompareProps) {
  const [isInCompare, setIsInCompare] = useState(
    () => typeof window !== 'undefined' && getShortlist().includes(vehicleId)
  );
  const [showLimitDialog, setShowLimitDialog] = useState(false);

  function handleClick() {
    if (isInCompare) {
      removeFromShortlist(vehicleId);
      setIsInCompare(false);
      return;
    }
    if (isShortlistFull()) {
      setShowLimitDialog(true);
      return;
    }
    addToShortlist(vehicleId);
    setIsInCompare(true);
  }

  return (
    <>
      {isInCompare ? (
        <Button variant="warning" className="w-full lg:w-fit" onClick={handleClick}>
          <Minus className="size-4" aria-hidden />
          Remove from compare
        </Button>
      ) : (
        <TrackingEventWrapper trackingEvent={{ event: 'add_to_compare', label: `${make} ${model}` }}>
          <Button variant="primary" className="w-full lg:w-fit" onClick={handleClick}>
            <Plus className="size-4" aria-hidden />
            Add to compare
          </Button>
        </TrackingEventWrapper>
      )}
      <CompareLimitDialog open={showLimitDialog} onOpenChange={setShowLimitDialog} />
    </>
  );
}
